import { useQuery } from '@tanstack/react-query';

import dealPageService from '~/services/cruises/DealPageService';

import { dealPageQueryKeys } from './dealPageQueryKeys';

export function useGetDealPage(dealId: string, enabled = true) {
  return useQuery({
    queryKey: dealPageQueryKeys.detail(dealId),
    queryFn: () => dealPageService.getById(dealId),
    enabled: !!dealId && enabled,
  });
}
